import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

const SidenavCollapsibleGroupHeader = ({ href, active, onClick, children })=>{
    // Non-navigable collapsible group: renders as div with click handler for toggling
    if (!href) {
        return jsx("div", {
            className: "cb-sidenav-collapsible-group",
            "data-testid": "sidenav-collapsible-group-header",
            onClick: onClick,
            children: children
        });
    }
    // Navigable group: renders as anchor for both active and inactive states
    return jsx("a", {
        className: classNames('cb-sidenav-collapsible-group', 'item-link', {
            active
        }),
        "data-testid": "sidenav-collapsible-group-header",
        href: href,
        onClick: onClick,
        children: children
    });
};
SidenavCollapsibleGroupHeader.displayName = 'Sidenav.CollapsibleGroup.Header';

export { SidenavCollapsibleGroupHeader };
//# sourceMappingURL=Sidenav.CollapsibleGroup.Header.es.js.map
